import axios from 'axios';

export const customerAccountService = {
  async getSites(leadId, { includeArchived = false } = {}) {
    const response = await axios.get(`/crm/leads/${leadId}/sites`, {
      params: includeArchived ? { include_archived: true } : {},
    });
    return response.data.sites || [];
  },

  async createSite(leadId, site) {
    const response = await axios.post(`/crm/leads/${leadId}/sites`, site);
    return response.data;
  },

  async bulkCreateSites(leadId, lines) {
    const response = await axios.post(`/crm/leads/${leadId}/sites/bulk`, { lines });
    return response.data;
  },

  async updateSite(leadId, siteId, site) {
    const response = await axios.patch(`/crm/leads/${leadId}/sites/${siteId}`, site);
    return response.data;
  },

  async archiveSite(leadId, siteId) {
    const response = await axios.post(`/crm/leads/${leadId}/sites/${siteId}/archive`);
    return response.data;
  },

  async restoreSite(leadId, siteId) {
    const response = await axios.post(`/crm/leads/${leadId}/sites/${siteId}/restore`);
    return response.data;
  },

  async getSiteHistory(leadId, siteId) {
    const response = await axios.get(`/crm/leads/${leadId}/sites/${siteId}/history`);
    return response.data;
  },

  async getContacts(leadId, { includeArchived = false } = {}) {
    const response = await axios.get(`/crm/leads/${leadId}/contacts`, {
      params: includeArchived ? { include_archived: true } : {},
    });
    return response.data.contacts || [];
  },

  async createContact(leadId, contact) {
    const response = await axios.post(`/crm/leads/${leadId}/contacts`, contact);
    return response.data;
  },

  async updateContact(leadId, contactId, contact) {
    const response = await axios.patch(`/crm/leads/${leadId}/contacts/${contactId}`, contact);
    return response.data;
  },

  async archiveContact(leadId, contactId) {
    const response = await axios.post(`/crm/leads/${leadId}/contacts/${contactId}/archive`);
    return response.data;
  },

  async restoreContact(leadId, contactId) {
    const response = await axios.post(`/crm/leads/${leadId}/contacts/${contactId}/restore`);
    return response.data;
  },

  async duplicateProposalToSites(leadId, proposalId, siteIds) {
    const response = await axios.post(
      `/crm/leads/${leadId}/proposals/${proposalId}/duplicate-to-sites`,
      { site_ids: siteIds }
    );
    return response.data;
  },
};
